import request from '@core/services/request';

export const redirectAPI = {
	generateCode: (redirectRequest: any) => request.post(`/Redirect/GenerateCode`, redirectRequest),
	getInfo: (redirectId: any) => request.get(`/Redirect/GetInfo?id=${redirectId}`),
	validate: (guessedCode: any, redirectId = '') => request.post(`/Redirect/Validate?id=${redirectId}&guessedCode=${guessedCode}`),
	hasAnyActiveApprovalCodesForHash: (contextHash: any) => request.get(`/Redirect/HasAnyActiveApprovalCodesForHash?contextHash=${contextHash}`),
	internalApproval: (guessedCode: any, contextHash: any) => request.get(`/Redirect/InternalApproval?guessedCode=${guessedCode}&contextHash=${contextHash}`),
	sendCode: (redirectId: any) => request.post(`/Redirect/SendCode?id=${redirectId}`),
	twilioResend: (redirectId: any) => request.post(`/Redirect/TwilioResend?id=${redirectId}`),
};
